import React, { useMemo } from "react";
export enum InfoSectionType {
  page,
  modal
}
const heading = "Welcome to Online Order Reconciliation";
const description = "Easily track orders and payouts from Swiggy and Zomato in one place. Simplify reconciliation, identify discrepancies, and get clear payment insights.";
const steps_info = [{
  icon: "card-search-icon",
  title: "Identify Payment Errors",
  description: "Quickly spot payment discrepancies to prevent lost revenue and reduce costs.",
},
{  icon: "recon-report-view-icon",
  title: "Download Reports & Uncover Insights",
  description: "Access reconciled, restaurant-level reports for full transparency."
  }, {
    icon: "track-payout-icon",
  title: "Track Order Payout Status",
  description: "Monitor orders where the payout amount differs from the calculated value and identify missing orders.",
}, {
  title: "Boost Efficiency",
  description: "Save time by reducing manual effort, allowing for faster tracking and reconciliation.",
  icon: "efficiency-icon"
}];

export default function ReconInfoSection({ type = InfoSectionType.page }: { type?: InfoSectionType }) {
  const isModalType = type === InfoSectionType.modal;
  const headerClass = useMemo(() =>
    isModalType ? "text-[24px] mb-[12px]" : "text-[30px] mb-[29px]"
    , [isModalType])
  const descriptionClass = useMemo(() =>
    isModalType ? "text-[18px] mb-[63px]" : "text-[18px] mb-[67px]"
    , [isModalType])
  const mainSectionClass = useMemo(() => isModalType ? "grid grid-cols-2" : "flex flex-col gap-[34px] bg-[#D9D9D933] py-[38px] px-[104px] rounded-[18px]", [isModalType]);

  return <div className={`flex flex-col bg-white text-black ${isModalType ? "items-start rounded-[16px]" : "items-center mb-[40px]"}`}>
    <div className={`font-semibold ${headerClass}`}>{heading}</div>
    <div className={descriptionClass}>{description}</div>
    <div className={`w-full ${mainSectionClass}`}>
      {steps_info.map(info => <div key={info.title}  className={`${isModalType ? "flex flex-col h-[195px] justify-center" : "flex"} gap-[25px]`}>
        <div className={`rista-sprite ${info.icon || ""}`}></div>
        <div className="flex flex-col gap-[6px]">
          <div className="font-semibold text-[18px]">{info.title}</div>
          <div className="text-[15px]">{info.description}</div>
        </div>
      </div>)}
    </div>
  </div>
}